import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-03/lesson-07/task-02";

const task: Slide = {
  title: "When are Sabine’s and Eyring’s formulas aproximately equal?",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
